import { ecId, ecLean, type JanusCtx, type Row } from '../ability/context';
import { readPlayerCharacterField } from '../display/player-character-field';
import { skipUnported } from '../unported';

export function deathDutyName(target: Row): string {
    return String(ecLean(target, 'encounter_creature_name') || readPlayerCharacterField(target, 'player_name') || 'Creature');
}
/** Call only after a present listener/status/source makes this particular duty due. */
export function skipDeathDuty(ctx: JanusCtx, target: Row, duty: string): void {
    if (ctx.dryRun) return;
    const text = `${deathDutyName(target)}: ${duty}`, id = ecId(target);
    if (!ctx.rows.some(row => row.roll_type_1 === 'janus_unported_skip' && row.roll_by === id && row.rolls_full === text))
        ctx.rows.push({ ...skipUnported(text), roll_by: id || null });
}
